/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Minimum_Duration_SecondsInputs */



/**
* | output |
* | --- |
* | "Minimum Duration (Seconds)" |
*
* @param {Minimum_Duration_SecondsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const minimum_duration_seconds = /** @type {((inputs?: Minimum_Duration_SecondsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Minimum_Duration_SecondsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Durée minimale (secondes)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Mindestdauer (Sekunden)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Durata minima (secondi)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Минимальная продолжительность (в секундах)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Duración mínima (segundos)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("最短持续时间（秒）")
	if (locale === "ja") return /** @type {LocalizedString} */ ("最小継続時間（秒）")
	if (locale === "hi") return /** @type {LocalizedString} */ ("न्यूनतम अवधि (सेकंड)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Duração mínima (segundos)")
	return /** @type {LocalizedString} */ ("Minimum Duration (Seconds)")
});